// import { TokenResponse } from "@react-oauth/google";
import { Home, HomeWithUserData } from "src/model_types/home.types";
import { backendApi } from "../api";
import { getIsSignedIn } from "../reducers/user";

// Define the new endpoints
const userEndpoints = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    getOwnHome: builder.query<Home, void>({
      query: () => ({
        url: `/home`,
        method: "GET",
      }),
      providesTags: (result) =>
        result ? [{ type: "Homes", id: String(result._id) }] : [],
    }),
    getHome: builder.query<HomeWithUserData, string>({
      query: (homeId: string) => {
        const isSignedIn = getIsSignedIn();
        return {
          url: `${isSignedIn ? "" : "/public"}/home/${homeId}`,
          method: "GET",
        };
      },
      providesTags: (result, error, homeId) =>
        result ? [{ type: "Homes", id: String(homeId) }] : [],
    }),
    getHomes: builder.query<Home[], string>({
      query: (query: string) => {
        const isSignedIn = getIsSignedIn();
        return {
          url: `${isSignedIn ? "" : "/public"}/homes${query}`,
          method: "GET",
          // query,
        };
      },
      providesTags: (result) =>
        result
          ? result.map(({ _id }) => ({ type: "Homes", id: String(_id) }))
          : [],
    }),
    likeHome: builder.mutation<Home, { homeId: string; like: boolean }>({
      query: ({ homeId, ...data }) => {
        return { url: `/home/like/${homeId}`, method: "PATCH", data };
      },
      invalidatesTags: (result, error, { homeId }) => [
        { type: "Homes", id: String(homeId) }, // Invalidate the specific home
        { type: "Homes", id: "LIST" }, // Invalidate list queries, if applicable
      ],
    }),
    createHome: builder.mutation<Home, Partial<Home>>({
      query: (data) => {
        return { url: "/home", method: "POST", data };
      },
      invalidatesTags: (result) =>
        result ? [{ type: "Homes", id: String(result._id) }] : [],
    }),
    updateHome: builder.mutation<Home, Partial<Home>>({
      query: ({ _id, ...data }) => {
        return { url: "/home", method: "PATCH", data };
      },
      invalidatesTags: (result, error, arg) =>
        arg && arg._id ? [{ type: "Homes", id: String(arg._id) }] : [],
    }),
  }),
});

// Export the hooks for the new endpoints
export const {
  useGetOwnHomeQuery,
  useGetHomesQuery,
  useGetHomeQuery,
  useCreateHomeMutation,
  useLikeHomeMutation,
  useUpdateHomeMutation,
} = userEndpoints;
